import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import {
    Body,
    ButtonAction,
    ButtonsContainer,
    DataBox,
    dialogPanel,
    dialogTitle
} from './styles'
import { IoCloseSharp } from 'react-icons/io5'

import OutlineCheckIcon from 'components/Icons/OutlineCheckIcon'
import { isFinishedStatus } from 'pages/NotificationTreatment'
import OutlineExclamationIcon from 'components/Icons/OutlineExclamationIcon'

interface PendingNotificationModalProps {
    handleCloseModal: () => void
    handleGoToStep: () => void
    isOpen: boolean
    isFinishedList: isFinishedStatus[]
    subtitle: string
}

const PendingStepModal: React.FC<PendingNotificationModalProps> = ({
    handleCloseModal,
    isOpen,
    isFinishedList,
    handleGoToStep,
    subtitle
}) => {

    return (
        <Transition
            appear
            show={isOpen}
            as={Fragment}
        >
            <Dialog
                as="div"
                className="relative z-10"
                onClose={handleCloseModal}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className={`${dialogPanel}`}>
                                <Dialog.Title as="h3" className={dialogTitle}>
                                    <p className="text-blueTheme text-xl font-semibold">
                                        Etapa pendente
                                    </p>
                                    <IoCloseSharp
                                        onClick={handleCloseModal}
                                        className="text-blueTheme h-8 w-8 p-1 cursor-pointer"
                                    />
                                </Dialog.Title>
                                <Body>
                                    <p className="text-xs">
                                        {subtitle}
                                    </p>
                                    <DataBox
                                        className={`grid gap-1 place-items-center mx-auto ${ isFinishedList?.length ? `grid-cols-${Math.min(isFinishedList.length)}`  : 'grid-cols-1' }`}>
                                        {isFinishedList?.map(
                                            (step, idx) => {
                                                const treatLabelText = step.label==="Finalizar notificação"?"Finalização":step.label
                                                return (
                                                    <div
                                                        key={idx}
                                                        className="flex flex-col justify-center items-center"
                                                    >
                                                        <div className="flex items-center gap-1">
                                                            {step.isDone ? (
                                                                <OutlineCheckIcon
                                                                    width="16"
                                                                    height="height"
                                                                    color={
                                                                        '#5FD290'
                                                                    }
                                                                />
                                                            ) : (
                                                                <OutlineExclamationIcon color='#F0B323' height={'16'} width={'16'} />
                                                            )}
                                                            <span
                                                                className={`
                                                                    text-sm
                                                                    ${step.isDone
                                                                    ? 'text-[#5FD290]'
                                                                    : 'text-[#F0B323]'
                                                                    }`}
                                                            >
                                                                {treatLabelText}
                                                            </span>
                                                        </div>
                                                        <span className='text-sm'>
                                                            {step.isRequired
                                                                ? 'Obrigatório'
                                                                : 'Facultativo'}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        )}
                                    </DataBox>
                                    <ButtonsContainer>
                                        <ButtonAction
                                            onClick={() => {
                                                handleCloseModal()
                                            }}
                                            type="button"
                                            className="text-blueTheme text-sm"
                                        >
                                            OK
                                        </ButtonAction>

                                        <ButtonAction
                                            onClick={handleGoToStep}
                                            className="bg-blueTheme text-white text-sm"
                                        >
                                            Ir para a etapa pendente
                                        </ButtonAction>
                                    </ButtonsContainer>
                                </Body>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export { PendingStepModal }
